const Skills = [
  {
    id: 1,
    category: "Programming Languages",
    items: ["Python", "JavaScript", "C"]
  },
  {
    id: 2,
    category: "Frameworks & Libraries",
    items: ["React", "Next.js", "Flask", "Laravel"]
  },
  {
    id: 3,
    category: "Machine Learning & AI",
    items: ["Scikit-learn", "TensorFlow", "PyTorch"]
  },
  {
    id: 4,
    category: "Database & Backend",
    items: ["MySQL / MariaDB", "SQLite", "Firebase Firestore", "Firebase Realtime Database"]
  },
  {
    id: 5,
    category: "Other Skills",
    items: ["HTML", "CSS", "Responsive Design", "REST APIs", "Git & GitHub", "Agile / SDLC", "Leadership", "Communication", "Problem-solving", "Teamwork", "LaTeX", "MS Office", "Languages: Bangla, English, Hindi"]
  }
];

export default Skills;
